import React, { ReactNode, useEffect, useRef } from 'react'
import useOnScreen from 'src/hooks/useOnScreen';

type Props = {
  children: ReactNode;
  loadMoreData: () => void
}

const FlatListV2 = ({ children, loadMoreData }: Props) => {
  const ref = useRef();
  const hasLoaded = useRef(false);

  const isVisible = useOnScreen(ref, { threshold: 0 });

  useEffect(() => {
    if (isVisible && !hasLoaded.current) {
      loadMoreData();
      hasLoaded.current = true;
    }
  }, [isVisible]);

  return (<div ref={ref}>{children}</div>);
}

export default FlatListV2